// material-ui
import { useTheme } from '@mui/material/styles';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  return (
    <img
      src="/logo.png"
      alt="Farmer Survey Icon"
      width="40"
      height="40"
      style={{ objectFit: 'contain', display: 'block' }}
    />
  );
}
